import {
  INC_LOADING,
  DEC_LOADING,
  SET_ERROR_MESSAGE,
  SET_SNACKBAR_MESSAGE
} from '@/modules/common/store/mutation-types'
import {
  FETCH_DISBURSEMENT_ORDERS,
  STOP_CASH_PAYMENT,
  CANCEL_DISBURSEMENT_ORDER,
  FETCH_DISBURSEMENT_ORDERS_FOR_ORGANIZATIONS,
  FETCH_DISBURSEMENT_ORDER_STATISTIC, FETCH_DISBURSEMENT_ORDER_SINGLE, CONFIRM_CASH_PAYMENT
} from './action-types'

import {
  SET_DISBURSEMENT_ORDER_STATISTICS,
  SET_DISBURSEMENT_ORDERS,
  UPDATE_DISBURSEMENT_ORDERS
} from './mutation-types'

import i18n from '@/i18n'
import { loadingStateWrapper } from '@/modules/common/store/tools'

export default {
  namespaced: true,
  state: function () {
    return {
      disbursementOrders: [],
      disbursementOrderStatistics: [],
    }
  },
  getters: {
    disbursementOrdersByCollectionPlan: (state) => {
      if (!state.disbursementOrders) {
        return {}
      }
      const map = {}
      state.disbursementOrders.forEach(disbursementOrder => {
        if (!map[disbursementOrder.plan]) {
          map[disbursementOrder.plan] = {
            hasStopCashPayments: false,
            disbursementOrders: [],
          }
        }

        if (disbursementOrder.stop_cash_payments) {
          map[disbursementOrder.plan].hasStopCashPayments = true
        }
        map[disbursementOrder.plan].disbursementOrders.push(disbursementOrder)
      })
      return map
    }
  },
  mutations: {
    [SET_DISBURSEMENT_ORDERS]: (state, data) => {
      state.disbursementOrders = data
    },
    [SET_DISBURSEMENT_ORDER_STATISTICS]: (state, data) => {
      state.disbursementOrderStatistics = data
    },
    [UPDATE_DISBURSEMENT_ORDERS]: (state, disbursementOrder) => {
      const index = state.disbursementOrders.findIndex(item => item.id === disbursementOrder.id)
      if (index !== -1) {
        state.disbursementOrders.splice(index, 1, disbursementOrder)
      }
    }
  },
  actions: {
    [FETCH_DISBURSEMENT_ORDERS]: async ({
      commit,
      rootGetters
    }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const { data, error } = await rootGetters.restApi.get('disbursementorder/order')
        if (data) {
          commit(SET_DISBURSEMENT_ORDERS, data)
        } else {
          commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        }
      } catch (error) {
        commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [FETCH_DISBURSEMENT_ORDER_SINGLE]: async ({
      commit,
      rootGetters
    }, { url }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const { data, error } = await rootGetters.restApi.get(url)
        if (data) {
          commit(UPDATE_DISBURSEMENT_ORDERS, data)
        } else {
          commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        }
      } catch (error) {
        commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [FETCH_DISBURSEMENT_ORDER_STATISTIC]: async (
      context,
      { organizationId }
    ) => {
      return loadingStateWrapper(context, async () => {
        const { data, error } = await context.rootGetters.restApi.get(`organization/${organizationId}/disbursement_order_statistic/`)
        if (data) {
          context.commit(SET_DISBURSEMENT_ORDER_STATISTICS, data)
        } else {
          context.commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        }
      }, async (error) => {
        await context.commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      })
    },
    [FETCH_DISBURSEMENT_ORDERS_FOR_ORGANIZATIONS]: async (
      {
        commit,
        rootGetters
      },
      { organizationIds }
    ) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const { data, error } = await rootGetters.restApi.get('disbursementorder/order/?organization=' + organizationIds.join(','))
        if (data) {
          commit(SET_DISBURSEMENT_ORDERS, data)
        } else {
          commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        }
      } catch (error) {
        commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [STOP_CASH_PAYMENT]: async ({
      commit,
      dispatch,
      rootGetters
    }, { disbursementOrderId, collectionName, collectionPlanUrl }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const { data, error } = await rootGetters.restApi.patch(`disbursementorder/order/${disbursementOrderId}/stop_cash_payments/`)
        await Promise.allSettled(rootGetters["payment/cashPaymentsByCollectionPlan"][collectionPlanUrl].map(cashPayment => {
          return dispatch('payment/' + CONFIRM_CASH_PAYMENT, { cashPayment }, { root: true })
        }))
        if (data) {
          commit(UPDATE_DISBURSEMENT_ORDERS, data)
          commit(SET_SNACKBAR_MESSAGE, { message: i18n.t('messages.success.stop_cash_payment', { collection: collectionName }) }, { root: true })
        } else {
          commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        }
      } catch (error) {
        const errorMessages = error.response.data.join('; ')
        commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${errorMessages}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [CANCEL_DISBURSEMENT_ORDER]: async ({
      commit,
      rootGetters
    }, disbursementOrderId) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const { data, error } = await rootGetters.restApi.patch(`disbursementorder/order/${disbursementOrderId}/cancel/`)
        if (data) {
          commit(UPDATE_DISBURSEMENT_ORDERS, data)
        } else {
          commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        }
      } catch (error) {
        commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    }
  }
}
